module.exports = __webpack_public_path__ + "images/ai_recommendations/yen-cb0793aeaa3f48064ac20bbc5cb16970.svg";